export default __webpack_public_path__ + "static/media/bottom.19c0f672.jpg";